var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["col-" + _vm.colSize] }, [
    _vm.prompt
      ? _c("div", { staticClass: "form-page" }, [
          _c("p", { staticClass: "text-justify" }, [
            _vm._v("\n      " + _vm._s(_vm.prompt) + "\n    "),
          ]),
        ])
      : _vm.promptHTML
      ? _c("div", { staticClass: "form-page" }, [
          _c("p", {
            staticClass: "text-justify",
            domProps: { innerHTML: _vm._s(_vm.promptHTML) },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.val,
            expression: "val",
          },
        ],
        staticClass: "text-area",
        attrs: {
          id: _vm.labelValue,
          cols: "4",
          rows: "3",
          maxlength: _vm.maxlength,
        },
        domProps: { value: _vm.val },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.val = $event.target.value
            },
            _vm.handleChange,
          ],
        },
      }),
      _vm._v(" "),
      _vm.prompt
        ? _c(
            "label",
            { staticClass: "d-none", attrs: { for: _vm.labelValue } },
            [_vm._v(_vm._s(_vm.prompt))]
          )
        : _vm.promptHTML
        ? _c("label", {
            staticClass: "d-none",
            attrs: { for: _vm.labelValue },
            domProps: { innerHTML: _vm._s(_vm.promptHTML) },
          })
        : _c(
            "label",
            { staticClass: "d-none", attrs: { for: _vm.labelValue } },
            [_vm._v(_vm._s(_vm.$t("custom-fields.fields.text.label")))]
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }